import React from "react";
import localeUtils from "../utils/locales";
import { isNative } from "../utils/native";

export default class CookieCat extends React.Component {
  componentDidMount() {
    this.initCookieCat();
  }

  initCookieCat = () => {
    const theme = "ocean";
    const locale = localeUtils.getLocale(i18n.getCurrentLocale());
    if (Mulligan.Brand.Cookies.notify && !isNative()) {
      //optional chaining no supported in mulligan
      if (window.CookieCat && window.CookieCat.init) {
        window.CookieCat.init({
          app: "mulligan",
          theme: theme,
          locale: locale.rfc,
        });
      }
    }
  };

  render() {
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/cookie-cat.jsx
 **/